import { useContext } from 'react';
import DeepLinkContext from '../context/deepLinkContext';

/**
 * useDeepLinkContext is a convenience hook to access the deeplink context
 */
export default function useDeepLinkContext() {
  return useContext(DeepLinkContext);
}
